module.exports = __webpack_public_path__ + "img/Picture13.64de8302.jpg";